import { render, staticRenderFns } from "./RdiIndex.vue?vue&type=template&id=70ff1906"
import script from "./RdiIndex.vue?vue&type=script&lang=js"
export * from "./RdiIndex.vue?vue&type=script&lang=js"
import style0 from "./RdiIndex.vue?vue&type=style&index=0&id=70ff1906&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports